// src/docs/DocsProjectManagement.js
import React from "react";
import { Container, Typography, Box } from "@mui/material";

const DocsProjectManagement = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Main Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
        Finalizing, Canceling, & Withdrawing Tokens (Project Management)
      </Typography>

      {/* Overview */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        As a project owner on CrowdLaunch, you have full control over the lifecycle of your project sale.
        You can finalize the sale once the fundraising period has ended, cancel the sale if necessary,
        or withdraw any unsold shares. These actions are vital to ensuring that your project’s fundraising
        and share distribution proceed securely and efficiently.
      </Typography>

      {/* Finalizing the Sale */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Finalizing the Sale
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Once the project sale has ended, you can finalize the sale using the <code>finalizeSale</code> function.
        If the funds raised meet or exceed the soft cap, the collected funds are transferred to your project wallet.
        If the soft cap is not met, the contract automatically enables refunds so that investors can reclaim their contributions.
      </Typography>

      {/* Canceling the Sale */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Canceling the Sale
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        In some cases, you may need to cancel the project sale. By invoking the <code>cancelSale</code> function,
        the sale is halted and refunds are enabled for all investors. The platform also can manually cancel a sale if it is deemed necessary.
      </Typography>

      {/* Withdrawing Tokens */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Withdrawing Tokens
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        After a successful sale, any unsold shares can be withdrawn.
        You have the option to withdraw the shares back to your wallet or burn them (i.e., send them to a burn address)
        to reduce the circulating supply.  </Typography>



      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF" }}>
        By mastering these project management functions, you ensure that your project sale runs smoothly and that
        all funds and shares are handled according to your project’s needs. Finalizing, canceling, and withdrawing tokens
        are essential steps to maintain transparency, trust, and control over your tokenized project.
      </Typography>
    </Container>
  );
};

export default DocsProjectManagement;
